import React from 'react';
import { motion } from 'framer-motion';
import './LoadingSpinner.css';

/**
 * LoadingSpinner Component
 * Reusable loading spinner for various loading states
 */
function LoadingSpinner({ 
  size = 'medium',
  message = 'Loading...',
  variant = 'default',
  showMessage = true
}) {
  
  return (
    <div className={`loading-spinner-container loading-spinner-${size}`}>
      <motion.div 
        className={`loading-spinner loading-spinner-${variant}`}
        animate={{ rotate: 360 }}
        transition={{
          duration: 1,
          repeat: Infinity,
          ease: "linear"
        }}
      >
        <div className="spinner-circle"></div>
      </motion.div>
      
      {showMessage && (
        <motion.div 
          className="loading-message"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          {message}
        </motion.div>
      )}
    </div>
  );
}

export default LoadingSpinner;
